@if (isSessionTimeoutMode) {
    <div mat-dialog-content class="confirmation-dialog session-timeout-dialog">
        <div class="composite-images" aria-hidden="true">
            <srp-icon icon="timer" size="40px" variant="symbols-outlined"></srp-icon>
        </div>
        <h2 mat-dialog-title id="confirmation-title-default">{{ data.heading }}</h2>
        <p class="session-timeout-description">{{ data.description }}</p>
        <p class="session-timeout-countdown">{{ countdownDisplay }}</p>
        @if (data.supportingText) {
            <p class="session-timeout-supporting-text">{{ data.supportingText }}</p>
        }
        @if (data.supportingText2) {
            <p class="session-timeout-supporting-text">{{ data.supportingText2 }}</p>
        }
    </div>

    <div class="action-buttons session-timeout-actions">
        <srp-button class="cancel-btn" (click)="cancel()" (keydown.enter)="cancel()">{{ data.button_one }}</srp-button>
        <srp-button class="remove-btn" (click)="confirm()" (keydown.enter)="confirm()" [attr.cdkFocusInitial]="true">{{ data.button_two }}</srp-button>
    </div>
} @else {
    <div mat-dialog-content class="confirmation-dialog">
        <div class="composite-images" aria-hidden="true">
            <srp-icon icon="how_to_reg" size="40px" variant="symbols-outlined"></srp-icon>
        </div>
        <h2 mat-dialog-title id="confirmation-title">{{ data.heading }}</h2>
        <p id="confirmation-description">{{ data.description }}</p>
    </div>

    <div class="validation-row">
        <p class="validation-heading">
            <strong>Validation Via</strong>
        </p>

        <div class="radio-group">
            <label class="radio-option">
                <input type="radio" name="validateVia" value="email" [(ngModel)]="selectedValidateVia"
                [checked]="selectedValidateVia === 'email'">
                Email
            </label>
            <label>
                <input type="radio" name="validateVia" value="phone" [(ngModel)]="selectedValidateVia" [checked]="selectedValidateVia === 'phone'">
                Phone
            </label>
            <label>
                <input type="radio" name="validateVia" value="onSite" [(ngModel)]="selectedValidateVia" [checked]="selectedValidateVia === 'onSite'">
                On-Site
            </label>
        </div>
    </div>

    <div class="action-buttons">
        <srp-button class="cancel-btn" (click)="cancel()" (keydown.enter)="cancel()">{{ data.button_one }}</srp-button>
        <srp-button class="remove-btn" (click)="confirm()" (keydown.enter)="confirm()" [attr.cdkFocusInitial]="true">{{ data.button_two }}</srp-button>
    </div>
}
